var $slideout = $('#notif');
if (document.querySelector('.fraction__selector')) {
    var fractionSelector = document.querySelector('.fraction__selector').innerHTML;
}


// for (let index = 0; index < lengths.length; index++) {
//    lengths[index].text('')
    
// }
//Product Page JS

function calcPriceWithCutItems () {
    var current_price = Number($('#ProductPrice-product-template').text().trim().replace('$', ''));
    var subtotal = 0;
    var total = current_price;
    var items_count = 0;

    current_price = Number.parseFloat(current_price).toFixed(2) * Number($('[name="quantity"]').val());

    $('.cut-items').find('.cut-item').each(function(){
        subtotal += Number($(this).find('.product-form__quantity').val()) * Number($('#cut-to-size-price').data('price')) / 100;
        items_count += Number($(this).find('.product-form__quantity').val());
    });

    total = Number(current_price) + subtotal;
    $('.cut-count').text(`${items_count}`);
    $('.cut-subtotal').text(`$${Number.parseFloat(subtotal).toFixed(2)}`);
    $('.cut-total').text(`$${Number.parseFloat(total).toFixed(2)}`);
    
}

function showNotification (msg) {
    $slideout.find('p').text(msg);
    $slideout.addClass('visible');
    setTimeout(() => {
        $slideout.removeClass('visible');
    }, 4000);
}

$(document).on('click', '.add--cut-size-item', function() {
    var isValid = true;
    $('.cut-input input').each(function(){
        if (!$(this).val()) {
            $('.cut-message').removeClass('active');
            $('.cut-error').addClass('active');
            isValid = false;
        }
    });
    if (!isValid) {
        return false;
    }
    var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    var uniqid = randLetter + Date.now();

    var cut_item = `<div class="cut-item active">
        <input type="hidden" name="properties[Custom Cut: 0 X 0]" class="cut-data" value="0">
        <div class="product-form__item product-form__item--width">
            <div class="cal">
                <div class="cal-size">
                    <label for="cut-width--${uniqid}">Width in Inches</label>
                    <input type="number" id="cut-width--${uniqid}" step="1" min="0" placeholder="" class="product-form__input product-form__width cut-input">
                </div>
                <div class="cal-size">
                    <label for="cut-width--${uniqid}">Fraction</label>
                    ${fractionSelector}
                </div>
            </div>
        </div>
        <div class="product-form__item product-form__item--length">
            <div class="cal">
                <div class="cal-size">
                    <label for="cut-length--${uniqid}">Length in Inches</label>
                    <input type="number" id="cut-length--${uniqid}" step="1" min="0" placeholder="" class="product-form__input product-form__length cut-input">
                </div>
                <div class="cal-size">
                    <label for="cut-length--${uniqid}">Fraction</label>
                    ${fractionSelector.replace('fraction__width', 'fraction__length')}
                </div>
            </div>
        </div>
        <div class="product-form__item product-form__item--quantity">
            <label for="cut-quantity--${uniqid}">Quantity</label>
            <input type="number" id="cut-quantity--${uniqid}" min="1" step="1" class="product-form__input product-form__quantity cut-input" value="0">
        </div>
        <div class="product-form__item product-form__item--info">
            <span class="edit-cut_item">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    width="528.899px" height="528.899px" viewBox="0 0 528.899 528.899" style="enable-background:new 0 0 528.899 528.899;"
                    xml:space="preserve">
                    <title>Edit</title>
                    <g>
                        <path d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981
                            c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611
                            C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069
                            L27.473,390.597L0.3,512.69z"/>
                    </g>
                </svg>
                Edit
            </span>
            <span class="add-cut_item">
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88"><title>add</title><path d="M61.44,0A61.46,61.46,0,1,1,18,18,61.25,61.25,0,0,1,61.44,0ZM88.6,56.82v9.24a4,4,0,0,1-4,4H70V84.62a4,4,0,0,1-4,4H56.82a4,4,0,0,1-4-4V70H38.26a4,4,0,0,1-4-4V56.82a4,4,0,0,1,4-4H52.84V38.26a4,4,0,0,1,4-4h9.24a4,4,0,0,1,4,4V52.84H84.62a4,4,0,0,1,4,4Zm8.83-31.37a50.92,50.92,0,1,0,14.9,36,50.78,50.78,0,0,0-14.9-36Z"/></svg>
                Add
            </span>
            <span id="item--${uniqid}" class="remove-cut_item">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>Remove</title><path d="M12 0c-4.992 0-10 1.242-10 3.144 0 .406 3.556 18.488 3.633 18.887 1.135 1.313 3.735 1.969 6.334 1.969 2.601 0 5.199-.656 6.335-1.969.081-.404 3.698-18.468 3.698-18.882 0-2.473-7.338-3.149-10-3.149zm0 1.86c4.211 0 7.625.746 7.625 1.667 0 .92-3.414 1.667-7.625 1.667s-7.625-.746-7.625-1.667 3.414-1.667 7.625-1.667zm4.469 19.139c-.777.532-2.418 1.001-4.502 1.001-2.081 0-3.721-.467-4.498-.998l-.004-.021c-1.552-7.913-2.414-12.369-2.894-14.882 3.55 1.456 11.304 1.455 14.849-.002-.868 4.471-2.434 12.322-2.951 14.902zm-7.872-7.418l-.492-.323 1.824-.008.78 1.667-.506-.32c-.723 1.146-1.027 1.764-.796 2.481-1.823-1.798-1.622-2.182-.81-3.497zm.622-1.304l.781-1.418c.195-.38 1.251-.075 1.688.899l-.797 1.445-1.672-.926zm2.673 5.175h-1.729c-.427.013-.672-1.061-.031-1.915h1.761v1.915zm.058-4.886l.524-.289c-.652-1.188-1.044-1.753-1.781-1.898 2.451-.729 2.593-.41 3.445.981l.521-.275-.79 1.654-1.919-.173zm3.059.005l.911 1.474c.236.355-.546 1.129-1.607 1.035l-.928-1.501 1.624-1.008zm-1.549 4.846l-.004.583-1.028-1.616 1.054-1.47-.006.6c1.354.011 2.037-.055 2.524-.63-.565 2.5-.942 2.533-2.54 2.533z"/></svg>
                Remove
            </span>
        </div>
    </div>`;
    $('.cut-items').append(cut_item);
    $('.cut-message').removeClass('active');
    $('.cut-container').addClass('active');
    calcPriceWithCutItems();
});

$(document).on('click', '.clear--cut-size-item', function(){
    $('.cut-items').empty();
    $('.cut-message').removeClass('active');
    calcPriceWithCutItems();
});

$(document).on('click', '.add-cut_item', function(){
    var $item = $(this).closest('.cut-item');
    var cut_count = 0;
    var isValid = true;
    var square = 0;
    $('.cut-item').each(function(){
        cut_count += Number($(this).find('.cut-data').val());
        if ($(this).find('.cut-data').val() == 0) {
            isValid = false;
        } else {
            var width = Number($(this).find('.product-form__width').val())+Number($(this).closest('.cut-item').find('.fraction__width').val());
            var length = Number($(this).find('.product-form__length').val())+Number($(this).closest('.cut-item').find('.fraction__length').val());    
            square += width * length * $(this).find('.product-form__quantity').val();
        }
    });

    if (isValid) {
        var product_wh = $('#SingleOptionSelector-0').val().replace(' inch', '').split('x');
        var width = Number($item.find('.product-form__width').val())+Number($(this).closest('.cut-item').find('.fraction__width').val());
        var length = Number($item.find('.product-form__length').val())+Number($(this).closest('.cut-item').find('.fraction__length').val());    
        var count = $('#Quantity').val();
        var product_square = product_wh[0] * product_wh[1] * $('#Quantity').val();
        if(Number(width) <= Number(product_wh[0]) && Number(length) <= Number(product_wh[1])){
                if (square <= product_square) {
                    $('.cut-container').removeClass('active');
                    $('.cut-item').removeClass('active');
                    $('.cut-message').removeClass('active');
                } else {
                    $('.cut-message').removeClass('active');
                    $('.cut-square-error').addClass('active');
                }
        } else {
            $('.cut-message').removeClass('active');
            $('.cut-size-error').addClass('active');
        }
    } else {
        $('.cut-message').removeClass('active');
        $('.cut-error').addClass('active');
    }
});

$(document).on('click', '.edit-cut_item', function(){
    $('.cut-container').addClass('active');
    $(this).closest('.cut-item').addClass('active');
    $('.cut-message').removeClass('active');
});

$(document).on('click', '.remove-cut_item', function(){
    $(this).closest('.cut-item').remove();
    $('.cut-message').removeClass('active');
    calcPriceWithCutItems();
});

$(document).on('change keyup', '.product-form__quantity', function(){
    calcPriceWithCutItems();
});

$(document).on('change', '.single-option-selector', function(){
    calcPriceWithCutItems();
});

$(document).on('change keyup', '[name="quantity"]', function(){
    calcPriceWithCutItems();
});

$(document).on('click', '.js-qty__adjust', function(){
    calcPriceWithCutItems();
});

$(document).on('change keyup', '.cut-input', function(){
    
    var scale = $('.single-option-selector').val().trim().split(" ");
    var widths = scale[0].split("x")[0];
    var lengths = scale[0].split("x")[1];
   
    if(Number($(this).closest('.cut-item').find('.product-form__width').val()) >= widths){
        $(this).closest('.cut-item').find('.fraction__width').prop('disabled', true);
    }

    else{
        $(this).closest('.cut-item').find('.fraction__width').prop('disabled', false);
    }

    if(Number($(this).closest('.cut-item').find('.product-form__length').val()) >= lengths){
        $(this).closest('.cut-item').find('.fraction__length').prop('disabled', true);
    }

    else{
        $(this).closest('.cut-item').find('.fraction__length').prop('disabled', false);
    }
    var width = Number($(this).closest('.cut-item').find('.product-form__width').val());
    var length = Number($(this).closest('.cut-item').find('.product-form__length').val());
    if ($(this).closest('.cut-item').find('.fraction__width').val()) {
        width += Number($(this).closest('.cut-item').find('.fraction__width').val());
    }

    if ($(this).closest('.cut-item').find('.fraction__length').val()) {
        length += Number($(this).closest('.cut-item').find('.fraction__length').val());
    }

    var quantity = $(this).closest('.cut-item').find('.product-form__quantity').val();

    if(width > 0 && length > 0 && quantity > 0) {
        $(this).closest('.cut-item').find('.cut-data').attr('name', `properties[Custom Cut: ${width} X ${length}]`);
        $(this).closest('.cut-item').find('.cut-data').val(quantity);
    } else {
        $(this).closest('.cut-item').find('.cut-data').attr('name', `properties[Custom Cut: 0 X 0]`);
        $(this).closest('.cut-item').find('.cut-data').val(0);
    }
});

calcPriceWithCutItems();



// Cart Page JS

function changeProperties(data, cls) {
    $.ajax({
        type: "POST",
        url: "/cart/change",
        data: data,
        success: function(data) {
            $('.cut-product-item').find(`.${cls}`).click();
        }
    });
}

$(document).on('click', '.cart-cut-item-plus', function(){
    var product_square = $(this).closest('td').find('p').text().split('/')[0].replace(' inch', '').split('x');
    var qty = $(this).closest('.cart__row').find('.js-qty__input').val();
    var ps = product_square[0] * product_square[1] * qty;
    var current_key = $(this).closest('.cart-properties__cut').find('.property-key').text().trim();
    var properties = {};
    var cutS = 0;
    $(this).closest('td').find('.cart-properties__cut').each(function(){
        var key = $(this).find('.property-key').text().trim();
        var val = Number($(this).find('.property-value').text().trim());
        if (current_key == key) {
            val++;
        }
        properties[key] = val;
        var cutWH = key.replace('Custom Cut: ', '').split('X');
        var s = Number(cutWH[0]) * Number(cutWH[1]) * val;
        cutS += s;
    });

    var data = {
        line: $(this).closest('.responsive-table__row').data('line'),
        quantity: $(this).closest('.responsive-table__row').data('qty'),
        properties: properties
    }

    if (cutS <= ps) {
        changeProperties(data, 'js-qty__adjust--plus');
    } else {
        showNotification('The custom cut size is bigger than product size.');
    }

});

$(document).on('click', '.cart-cut-item-minus', function(){
    var current_key = $(this).closest('.cart-properties__cut').find('.property-key').text().trim();
    var properties = {};
    var is_property = false;
    $(this).closest('td').find('.cart-properties__cut').each(function(){
        var key = $(this).find('.property-key').text().trim();
        var val = Number($(this).find('.property-value').text().trim());
        if (current_key == key) {
            val--;
        }

        if (val > 0) {
            properties[key] = val;
            is_property = true;
        }
    });

    var data = {};

    if (is_property) {
        data = {
            line: $(this).closest('.responsive-table__row').data('line'),
            quantity: $(this).closest('.responsive-table__row').data('qty'),
            properties: properties
        }
    } else {
        data = {
            line: $(this).closest('.responsive-table__row').data('line'),
            quantity: $(this).closest('.responsive-table__row').data('qty'),
            properties: {
                _propertyID: null
            }
        }
    }

    changeProperties(data, 'js-qty__adjust--minus'); 
});

$(document).on('click', '.remove-item', function(){
    var itemLine = $(this).data('item-line');
    var itemQty = $(this).data('item-qty');
    var cutQty = $('.cut-product-item').data('qty');
    var qty = cutQty - itemQty;
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
            line: itemLine,
            quantity: 0,
        },
    }).then((data) => {
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
                id: 42731011014884,
                quantity: qty,
            },
        }).then((data) => {
            window.location.href = '/cart';
        });
    });
});


// back to top button

var btn = $('#back-to-top');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});


// filter apply

$(document).on('click', '.collection-name a', function(){
    if ($(window).width() > 767) {
        setTimeout(() => {
            $('.pt-apply').click();
        }, 2500);
    }
});

$(document).on('click', '.filter-clear', function(){
    if ($(window).width() > 767) {
        setTimeout(() => {
            $('.pt-apply').click();
        }, 2500);
    }
});

// $("#SiteNavSearch").click(function(){
//     $(".notification").css('display', 'none');
// })

// var searchInterval = setInterval(searchElement, 500);
// function stopSearch() {
//     clearInterval(searchInterval);
// }

// function searchElement() {
//     if ($('.ets_fs_pagination').length > 0) {
//         stopSearch();
//         $('.ets_fs_block_filter_body').removeClass('ets_fs_open');
//         $('.ets_fs_filter_bar').each(function(){
//             const title = $(this).find('.ets_fs_filter_body').find('.ets_fs_block_filter_title').find('h3').text();
//             $(this).find('.ets_fs_filter_header').find('h3').text(title);
//         });

//         $('.ets_fs_block_filter_body li').click(function(){
//             var text = $(this).find('.ets_fs_label').text();
//             $('.ets_fs_block_filter_body').removeClass('ets_fs_open');
//             $(this).closest('.ets_fs_block_filter').find('.ets_fs_block_filter_title').find('h3').text(text);
//             console.log(1);
//             console.log(text);
//         });
//     }
// }

// setTimeout(function(){
//     stopSearch();
// },60000);

